import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { brl } from "@/lib/format";
import { Plus, Trash2 } from "lucide-react";
import { toast } from "sonner";

export default function Coupons() {
  const [list, setList] = useState([]);
  const [form, setForm] = useState({ code:"", discount_type:"percent", discount_value:10, min_total:0, max_uses:null, active:true });

  const load = () => api.get("/admin/coupons").then((r)=>setList(r.data));
  useEffect(() => { load(); }, []);

  const save = async () => {
    try {
      await api.post("/admin/coupons", { ...form, discount_value: Number(form.discount_value), min_total: Number(form.min_total) || 0 });
      toast.success("Cupom criado");
      setForm({ code:"", discount_type:"percent", discount_value:10, min_total:0, max_uses:null, active:true });
      load();
    } catch (err) { toast.error(err.response?.data?.detail || "Erro"); }
  };

  const del = async (c) => {
    if (!window.confirm(`Excluir cupom ${c.code}?`)) return;
    await api.delete(`/admin/coupons/${c.id}`);
    toast.success("Excluído"); load();
  };

  const typeLabel = (t) => ({percent:"% desconto", fixed:"R$ desconto", free_shipping:"Frete grátis"}[t] || t);

  return (
    <div className="space-y-5" data-testid="admin-coupons">
      <h1 className="font-serif text-3xl text-[#4A3B40]">Cupons</h1>
      <div className="grid md:grid-cols-3 gap-6">
        <div className="bg-white rounded-2xl border border-[#F9E1E8] p-5 h-fit">
          <h3 className="font-serif text-lg text-[#4A3B40] mb-3">Novo cupom</h3>
          <div className="space-y-3">
            <input className="cp" placeholder="CÓDIGO" value={form.code} onChange={(e)=>setForm({...form, code:e.target.value.toUpperCase()})} data-testid="coupon-code" />
            <select className="cp" value={form.discount_type} onChange={(e)=>setForm({...form, discount_type:e.target.value})}>
              <option value="percent">Percentual (%)</option>
              <option value="fixed">Valor fixo (R$)</option>
              <option value="free_shipping">Frete grátis</option>
            </select>
            {form.discount_type !== "free_shipping" && (
              <input className="cp" type="number" step="0.01" placeholder="Valor do desconto" value={form.discount_value} onChange={(e)=>setForm({...form, discount_value:e.target.value})} />
            )}
            <input className="cp" type="number" step="0.01" placeholder="Pedido mínimo (R$)" value={form.min_total} onChange={(e)=>setForm({...form, min_total:e.target.value})} />
            <input className="cp" type="number" placeholder="Limite de usos (opcional)" value={form.max_uses || ""} onChange={(e)=>setForm({...form, max_uses: e.target.value?Number(e.target.value):null})} />
            <button onClick={save} className="w-full btn-lara" data-testid="coupon-save"><Plus className="w-4 h-4" /> Criar</button>
          </div>
          <style>{`.cp{width:100%;border:1px solid #F9E1E8;background:#FFF9FA;border-radius:12px;padding:10px 14px;outline:none;font-size:14px}.cp:focus{border-color:#C9708B}`}</style>
        </div>
        <div className="md:col-span-2 space-y-2">
          {list.map((c) => (
            <div key={c.id} className="bg-white rounded-2xl border border-[#F9E1E8] p-4 flex items-center gap-4" data-testid={`coupon-row-${c.code}`}>
              <div className="bg-[#F9E1E8] text-[#C9708B] border-2 border-dashed border-[#E8A0B4] rounded-xl px-3 py-1.5 font-serif font-bold">{c.code}</div>
              <div className="flex-1">
                <p className="text-sm text-[#4A3B40]">{typeLabel(c.discount_type)} {c.discount_type!=="free_shipping" ? (c.discount_type==="percent"?`${c.discount_value}%`:brl(c.discount_value)) : ""}</p>
                <p className="text-xs text-[#8C7A80]">Mín. {brl(c.min_total)} • Usos: {c.uses || 0}{c.max_uses?`/${c.max_uses}`:""}</p>
              </div>
              <button onClick={()=>del(c)} className="text-[#E57373]"><Trash2 className="w-4 h-4" /></button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
